import React, { useState } from "react"
import { useSelector, useDispatch } from "react-redux"

import { NO, YES } from "const"
import {
    StoreType,
    ChangePackageSettings,
    setPackageSettings,
    moduleIds,
} from "client/store"
import {
    Collapse,
    PageForm,
    FormGroup,
    Label,
    RadioButton,
} from "client/components"

const Qid = () => {
    const settings = useSelector((state: StoreType) => state.package.packageSettings)
    const moduleList = useSelector((state: StoreType) => state.module.moduleList)
    const lang = useSelector((state: StoreType) => state.system.lang)
    const dispatch = useDispatch()

    const [show, setShow] = useState(false)

    const onChange = (newSettings: ChangePackageSettings) => {
        dispatch(setPackageSettings(newSettings))
    }

    const {
        qidModuleAccess,
    } = settings

    return (
        <Collapse
            show={show}
            title={moduleList[moduleIds.qid].name}
            onCollapse={() => setShow(!show)}
        >
            <PageForm>
                <FormGroup>
                    <Label>{lang.qidMasterAccess}</Label>
                    <FormGroup inline>
                        <RadioButton
                            checked={qidModuleAccess === NO}
                            onChange={() => onChange({ qidModuleAccess: NO })}
                            title={lang.no}
                        />
                        <RadioButton
                            checked={qidModuleAccess === YES}
                            onChange={() => onChange({ qidModuleAccess: YES })}
                            title={lang.yes}
                        />
                    </FormGroup>
                </FormGroup>
            </PageForm>
        </Collapse>
    )
}
export default Qid
